import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-video-modal',
  standalone: false,
  templateUrl: './video-modal.component.html',
  styleUrl: './video-modal.component.scss',
})
export class VideoModalComponent implements OnDestroy {
  @ViewChild('videoEl') videoEl!: ElementRef<HTMLVideoElement>;

  readonly videoSrc = 'https://dlebs5v4beuct.cloudfront.net/platform-introduction.mp4';

  constructor(public bsModalRef: BsModalRef) {}

  close(): void {
    const video = this.videoEl?.nativeElement;
    if (video) {
      video.pause();
      video.src = '';
      video.load();
    }
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {
    const video = this.videoEl?.nativeElement;
    if (video) {
      video.pause();
      video.src = '';
      video.load();
    }
  }
}
